var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButtonWithIcon',_vm._g(_vm._b({attrs:{"icon":"plus-circle","type":"add-new"}},'AppButtonWithIcon',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }